
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Maintenancerepail() {



  const cardData =
  {
    keyword: 'All Types of Maintenance Repair Work',
    heading: 'Anjali Enterprises: All Types of Maintenance Repair Work',
    headingDescription: 'Anjali Enterprises offers comprehensive maintenance and repair services for both residential and commercial spaces in Pune. Our expert team is equipped to handle a wide range of repair and maintenance tasks, ensuring your property remains functional, safe, and well-maintained at all times.',

    "topPlaces": [
        {
          "title": "Maintenance Repair Services",
          "description": "We provide professional maintenance and repair services for a variety of systems, including plumbing, electrical, HVAC, and more. Our team ensures timely and efficient repairs to keep your property in top condition."
        },
        {
          "title": "Commercial and Residential Repair Work",
          "description": "Whether it’s a residential property or a commercial space, we offer reliable repair services to address any issues. From minor repairs to large-scale fixes, we handle all aspects of property maintenance."
        },
        {
          "title": "Home Maintenance Solutions",
          "description": "Our home maintenance services include plumbing, electrical, carpentry, and HVAC repairs. We provide customized solutions to meet your home’s specific needs, ensuring comfort and safety for your family."
        },
        {
          "title": "Plumbing Repair",
          "description": "Anjali Enterprises offers expert plumbing repair services, including leak fixes, pipe installations, water heater repairs, and more. We ensure that your plumbing system operates smoothly and efficiently."
        },
        {
          "title": "Electrical Repair Services",
          "description": "Our certified electricians handle all electrical repairs, from wiring and circuit issues to lighting fixes. We ensure that your electrical systems are safe, functional, and up to code."
        },
        {
          "title": "HVAC Repair",
          "description": "We offer HVAC repair services to ensure your heating, ventilation, and air conditioning systems are working efficiently. Whether it’s an air conditioning unit or heating system, our technicians provide quick and reliable repairs."
        },
        {
          "title": "Carpentry Repair Work",
          "description": "Our skilled carpenters handle all types of repair work for wooden furniture, doors, windows, and more. We specialize in both minor repairs and larger restoration projects."
        },
        {
          "title": "Home Appliance Repair",
          "description": "Anjali Enterprises also offers repair services for home appliances, including refrigerators, washing machines, and ovens. Our technicians ensure that your appliances work smoothly and efficiently."
        },
        {
          "title": "Maintenance Contractors Pune",
          "description": "We are trusted maintenance contractors in Pune, providing professional repair services across all aspects of property maintenance. Our team is dedicated to delivering top-quality service and timely solutions."
        },
        {
          "title": "Office Maintenance Services",
          "description": "We provide comprehensive office maintenance services, including electrical repairs, plumbing fixes, and general upkeep. We ensure that your office space remains productive and operational with minimal downtime."
        },
        {
          "title": "Painting and Plastering Repairs",
          "description": "Our maintenance services include painting and plastering repairs, ensuring that your walls and ceilings look pristine. Whether it’s fixing cracks or applying a fresh coat of paint, we handle all painting and plastering repairs with precision."
        },
        {
          "title": "Routine Maintenance and Troubleshooting",
          "description": "We offer routine maintenance services to keep your property in excellent condition. Our team conducts thorough inspections and provides troubleshooting services to address any potential issues before they become major problems."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality maintenance repair work. We specialize in all types of maintenance and repair services, including electrical, plumbing, civil work, and more, ensuring your home or office remains in top condition. Get in touch for expert repair and maintenance services tailored to your specific needs. Serving Pune with professional and efficient maintenance repair work."
        }
      ],
      "tableData": [
        ["- Maintenance repair services", "- Commercial and residential repair work"],
        ["- Home maintenance solutions", "- Plumbing repair"],
        ["- Electrical repair services", "- HVAC repair"],
        ["- Carpentry repair work", "- Home appliance repair"],
        ["- Maintenance contractors Pune", "- Office maintenance services"],
        ["- Painting and plastering repairs", "- Routine maintenance and troubleshooting"],
        ["- Contact Anjali Enterprises for expert service", ""]
      ],
   

    "whychoose": [
  {
    "WhyChooseheading": "Comprehensive Maintenance and Repair Services",
    "WhyChoosedescription": "At Anjali Enterprises, we offer a broad range of maintenance and repair services, catering to residential, commercial, and industrial properties. Our services span electrical, plumbing, carpentry, HVAC, painting, and general maintenance. Whether you're dealing with routine maintenance or unexpected repairs, our team is fully equipped to handle all your needs efficiently and professionally."
  },
  {
    "WhyChooseheading": "Experienced and Skilled Professionals",
    "WhyChoosedescription": "Our team is made up of certified, highly trained professionals with extensive experience in the field of maintenance and repair work. With years of expertise under our belt, we deliver top-notch service, ensuring that every task is completed with precision, care, and efficiency. You can trust us to handle any issue, no matter how complex."
  },
  {
    "WhyChooseheading": "Timely and Efficient Service",
    "WhyChoosedescription": "We understand that maintenance and repair work often needs to be done quickly to prevent further damage or disruption. That’s why we prioritize timely and efficient service. Whether it’s an emergency or a routine task, we ensure that every job is completed within the agreed timeline, with minimal impact on your daily activities or business operations."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Anjali Enterprises is committed to offering affordable maintenance and repair services without compromising on quality. We provide transparent pricing with no hidden charges, ensuring that you receive a detailed and accurate estimate before work begins. Our goal is to deliver excellent value for your investment while meeting your specific maintenance needs."
  },
  {
    "WhyChooseheading": "Comprehensive Repairs Across All Systems",
    "WhyChoosedescription": "From electrical and plumbing repairs to HVAC, carpentry, and painting, we offer comprehensive repair services for every system in your home or business. Our skilled technicians are experienced in diagnosing and fixing issues across a wide range of systems, ensuring your property is running smoothly and efficiently. No matter the complexity, we approach each repair with precision and expertise."
  },
  {
    "WhyChooseheading": "Preventive Maintenance Services",
    "WhyChoosedescription": "Preventive maintenance is essential for reducing costly repairs and downtime. At Anjali Enterprises, we offer proactive maintenance services to ensure that your systems remain in top condition. By regularly inspecting and maintaining equipment, we help you avoid unexpected breakdowns, extend the lifespan of your assets, and save on future repair costs."
  },
  {
    "WhyChooseheading": "Emergency Repair Services",
    "WhyChoosedescription": "Emergencies happen at the most inconvenient times, which is why Anjali Enterprises offers 24/7 emergency repair services. Whether it’s a plumbing leak, electrical issue, or HVAC failure, our team is ready to respond quickly and efficiently to resolve urgent problems and minimize any disruption to your home or business operations."
  },
  {
    "WhyChooseheading": "Quality Materials and Equipment",
    "WhyChoosedescription": "We believe that high-quality repairs require high-quality materials. That's why we use only the best materials and equipment for every maintenance and repair job. This ensures that all repairs are durable, reliable, and long-lasting, giving you peace of mind and minimizing the chances of recurring issues."
  },
  {
    "WhyChooseheading": "Customer Satisfaction Guaranteed",
    "WhyChoosedescription": "Customer satisfaction is at the heart of everything we do. We take the time to listen to your needs, understand the scope of work, and deliver services that meet and exceed your expectations. Our team is dedicated to providing top-quality workmanship and ensuring you are completely satisfied with the results of every maintenance or repair job."
  },
  {
    "WhyChooseheading": "Eco-Friendly Solutions",
    "WhyChoosedescription": "At Anjali Enterprises, we are committed to reducing our environmental impact. We prioritize eco-friendly solutions in all of our maintenance and repair services. From using sustainable materials to employing energy-efficient practices, we ensure that our work not only meets your needs but also contributes to a greener, more sustainable future."
  }
]


  }

  const faqData = [
    {
      "question": "What types of maintenance and repair services do you offer?",
      "answer": "We offer a wide range of maintenance and repair services, including electrical repairs, plumbing services, HVAC maintenance, carpentry work, painting, and general repairs for residential, commercial, and industrial spaces."
    },
    {
      "question": "Are your technicians experienced and certified?",
      "answer": "Yes, all our technicians are highly trained, experienced, and certified in their respective fields. They adhere to industry standards and safety regulations to ensure that all work is completed professionally and safely."
    },
    {
      "question": "Do you provide emergency repair services?",
      "answer": "Yes, we provide emergency repair services 24/7. Whether it's a plumbing leak, electrical failure, or any other urgent repair, our team is ready to respond quickly and resolve the issue as soon as possible."
    },
    {
      "question": "How do I schedule maintenance or repair services?",
      "answer": "You can easily schedule maintenance or repair services by contacting us through our phone number or email. Our customer service team will assist you in booking a convenient time for the service."
    },
    {
      "question": "Do you offer preventive maintenance services?",
      "answer": "Yes, we offer preventive maintenance services to ensure that your systems and equipment are working efficiently. Regular maintenance can help prevent future breakdowns and reduce the need for costly repairs."
    },
    {
      "question": "What are the costs for maintenance and repair services?",
      "answer": "Our pricing is competitive and transparent. The cost will depend on the type of service required. We provide free estimates and ensure that our charges are clear with no hidden fees."
    },
    {
      "question": "Do you provide maintenance services for both residential and commercial properties?",
      "answer": "Yes, we offer maintenance and repair services for both residential and commercial properties. Whether it's a home, office, or industrial facility, we have the skills and expertise to handle your maintenance needs."
    },
    {
      "question": "How long will it take to complete a repair or maintenance task?",
      "answer": "The duration of the task depends on the type and complexity of the repair or maintenance service. We aim to complete all work efficiently and as quickly as possible, without compromising on quality."
    },
    {
      "question": "Are your repairs covered by a warranty?",
      "answer": "Yes, we offer warranties on our repair work to ensure that you’re satisfied with the results. If any issues arise after the repair, we will address them promptly."
    },
    {
      "question": "Why should I choose Anjali Enterprises for maintenance and repair work?",
      "answer": "Anjali Enterprises is known for providing reliable, high-quality maintenance and repair services. Our experienced team, transparent pricing, and commitment to customer satisfaction set us apart from others. We ensure your property remains in optimal condition with our expert services."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Vikram Shah",
      "text": "I hired Anjali Enterprises for some electrical repairs in my office, and I couldn't be more impressed. The team was quick, efficient, and handled everything professionally. I’ll definitely call them for future maintenance needs."
    },
    {
      "name": "Ms. Neha Reddy",
      "text": "The plumbing work done at my home by Anjali Enterprises was top-notch. The technicians were very knowledgeable, and they fixed the issue promptly. I appreciate their transparent pricing and excellent service."
    }
  ];
  


  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>


<Helmet>
  <title> Maintenance & Repair Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers all types of maintenance repair services, including commercial and residential repairs, plumbing, electrical, HVAC, carpentry, and appliance repairs. Call +91 8793220265 for home and office maintenance solutions in Pune." />
  <meta name="keywords" content="Maintenance Repair Services, Commercial and Residential Repair Work, Home Maintenance Solutions, Plumbing Repair, Electrical Repair Services, HVAC Repair, Carpentry Repair Work, Home Appliance Repair, Maintenance Contractors Pune, Office Maintenance Services, Painting and Plastering Repairs, Routine Maintenance and Troubleshooting" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Maintenance & Repair Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of maintenance repair services, including commercial and residential repairs, plumbing, electrical, HVAC, carpentry, and appliance repairs. Call +91 8793220265 for home and office maintenance solutions in Pune." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/maintenance-repair.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/maintenance-repair-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of maintenance repair services, including commercial and residential repairs, plumbing, electrical, HVAC, carpentry, and appliance repairs. Call +91 8793220265 for home and office maintenance solutions in Pune.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/maintenance-repair-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/maintenance-repair.jpg",
        "priceRange": "₹2000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/maintenance-repair-services",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "75"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Amit S"
            },
            "datePublished": "2024-05-15",
            "reviewBody": "We called Anjali Enterprises for plumbing and electrical repairs at our office. The team was fast, efficient, and professional. Very satisfied with the service!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha P"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "The maintenance work on our home was handled with care. They repaired the HVAC system and did some carpentry work too. Excellent service overall!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/maintenance-repair-services"
        },
        "keywords": "Maintenance Repair Services, Commercial and Residential Repair Work, Home Maintenance Solutions, Plumbing Repair, Electrical Repair Services, HVAC Repair, Carpentry Repair Work, Home Appliance Repair, Maintenance Contractors Pune, Office Maintenance Services, Painting and Plastering Repairs, Routine Maintenance and Troubleshooting"
      }
    `}
  </script>
</Helmet>



      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/15.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Maintenancerepail;